<template>
  <div id="avator">
    <div id="Avator">    
      <a href="https://ypigy.gitee.io/">
        <slot name="img"></slot>
      </a>
    </div>
    <div class="showDetail"><span>Back to Blog</span></div>
  </div>
</template>

<script>
  export default {
    name: "Avator",
    props: {
      imgLink: String
    }
  }
</script>

<style scoped lang="less">
  #avator {
    &:hover .showDetail {
      display: block;
    } 
  }
  #Avator {
    height: 1.875rem;
    width: 100%;
    // background-color: pink;
    position: relative;
    overflow: hidden;
    transition: 1.5s;      
    &:hover {
      transform: rotate(360deg);
      img {
        box-shadow: none;        
      }

    } 
    img {
      width: 1.125rem;
      height: 1.125rem;
      border: 0.0625rem @active-bgc solid;
      border-radius: 1rem;
      box-shadow: @box-shadow;
      display: block;
      margin: 0 auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%,-50%,0);
    }
  }
  .showDetail {
    position: absolute;
    top: 0.4rem;
    left: 1.8rem;
    color: #0071BC;
    display: none;
    font-family: 'PSYCHO';
  }
</style>